<template>
  <div
    v-if="$route.name === 'Order' || $route.name === 'OrderIframe'"
    class="animated fadeIn">
    <loading
      v-if="loading"
      message="Загружаем информацию о заказе..."/>
    <div v-else class="order-view">
      <h3 class="mb-2 h3">Заказ №{{order.id}} - {{order.description}}</h3>
      <div class="row">
        <div class="col-md-4">
          <div class="card">
            <div class="card-block order-view__block order-view__block--bordered">
              <order-status :order="order" :showSum="false"></order-status>
            </div>
            <div
              class="card-block order-view__block order-view__block--bordered">
              <div class="row">
                <div class="col-5 text-muted">Дата</div>
                <div class="col-7">{{order.date}}</div>
              </div>
              <div class="row">
                <div class="col-5 text-muted">Время</div>
                <div class="col-7">{{order.time}}</div>
              </div>
              <div class="row">
                <div class="col-5 text-muted">Город</div>
                <div class="col-7">{{order.techcenter.city.name}}</div>
              </div>
              <div class="row">
                <div class="col-5 text-muted">Адрес</div>
                <div class="col-7">{{order.techcenter.address}}</div>
              </div>
            </div>
            <div
              class="card-block order-view__block order-view__block--bordered">
              <div class="row">
                <div class="col-5 text-muted">Клиент</div>
                <div class="col-7">{{order.clientName}}</div>
              </div>
              <div class="row">
                <div class="col-5 text-muted">
                  Телефон
                  <span
                    class="text-danger"
                    v-if="order.clientPhone === '**********'"
                    v-b-tooltip.hover
                    title="Номер телефона клиента открывается за 1 час до приезде клиента, а также доступен при статусе 'В работе'. Если вам необходимо связаться с клиентом, то свяжитесь с ответственным мереджером в отделе продаж"
                  >
                      <i class="fa fa-exclamation-triangle"></i>
                    </span>
                </div>
                <div class="col-7">+7{{order.clientPhone}}</div>
              </div>
            </div>
            <div class="card-block order-view__block">
              <div class="row">
                <div class="col-5 text-muted">Ответственный</div>
                <div class="col-7">{{order.user.firstname}}
                  {{order.user.lastname}}
                </div>
              </div>
              <div class="row" v-if="order.sum">
                <div class="col-5 text-muted">Сумма по заказ-наряду</div>
                <div class="col-7">{{order.sum}} <i class="fa fa-rub"></i></div>
              </div>
              <div class="row" v-if="order.profit">
                <div class="col-5 text-muted">Комиссия</div>
                <div class="col-7">{{order.profit}} <i class="fa fa-rub"></i>
                </div>
              </div>
              <div class="row">
                <div class="col-5 text-muted">Создан</div>
                <div class="col-7">{{order.created}}</div>
              </div>
              <div class="row" v-if="order.amoId && !$route.meta.isIframe">
                <div class="col-5 text-muted">Id в amoCRM</div>
                <div class="col-7">
                  <a :href="'https://alarmru.amocrm.ru/leads/detail/' + order.amoId" target="_blank" @click.stop>
                    {{order.amoId}}
                  </a>
                </div>
              </div>

            </div>
          </div>
        </div>
      <div class="col-md-8">
        <comments :order="order"></comments>
        <order-history :order="order"></order-history>
      </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapState, mapActions} from 'vuex'
  import {ADD_TOAST_MESSAGE} from 'vuex-toast'
  import OrderStatus from './OrderStatus'
  import Comments from '../../components/Comments'
  import OrderHistory from './OrderHistory'
  export default {
    computed: {
      ...mapState({
        order: state => state.orderStore.order,
        currentUser: state => state.globalStore.user
      })
    },
    watch: {
      '$route': 'loadOrderData'
    },
    components: {
      OrderHistory,
      Comments,
      OrderStatus
    },
    data () {
      return {
        loading: false,
        id: null
      }
    },
    methods: {
      loadOrderData () {
        this.loading = true
        this.id = this.$route.params.id
        this.$store.dispatch('getOrderById', {id: this.id})
          .then(() => {
            this.loading = false
          })
          .catch(() => {
            this.loading = false
          })
      },
      getCommission (sum, profit) {
        if (sum !== null && profit !== null && this.currentUser.isAdmin) {
          return parseInt((profit / sum) * 100)
        }
        return false
      },
      ...mapActions({
        addToast: ADD_TOAST_MESSAGE
      })
    },
    created () {
      this.loadOrderData()
    }
  }
</script>
<style lang="scss" scoped>
  .order-view {
    &__block {
      line-height: 2em;
      &--bordered {
        border-bottom: 1px solid #f5f5f5;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// View.vue?18e75f10